import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Spinner } from "react-bootstrap";
import { cadastrarClinicaCompleta } from "../data/api/gsConnectApi";
import VariaveisGlobais from "../variaveis_globais/variaveis_globais";
import { pegarParametroUrl } from "../utils/utils";

function WelcomePage({ onContinue }) {
  const [loading, setLoading] = useState(false);
  const [dadosUrl, setDadosUrl] = useState(null);

  useEffect(() => {
    // Pegar parâmetros das variáveis globais já definidas no index.js
    const params = {
      idEmpresa: VariaveisGlobais.idClinica,
      idUsuario: VariaveisGlobais.idUsuario,
      token: VariaveisGlobais.token,
      usuario: VariaveisGlobais.usuario // usuario não está nas variáveis globais
    };
    
    // Verificar se todos os parâmetros necessários estão presentes
    if (params.idEmpresa && params.token) {
      setDadosUrl(params);
    }
  }, []);

  const extrairNomeDaString = (str) => {
    if (!str) return 'Clínica';
    // Remove caracteres especiais e números, mantém apenas letras e espaços
    return str.replace(/[^a-zA-ZÀ-ÿ\s]/g, '').trim() || 'Clínica';
  };

  const handleContinue = async () => {
    setLoading(true);
    try {
      if (!dadosUrl) {
        throw new Error('Parâmetros da URL não encontrados');
      }

      const resultado = await cadastrarClinicaCompleta(dadosUrl);
      console.log('Clínica criada com sucesso:', resultado);
      
      // Armazenar dados nas variáveis globais
      VariaveisGlobais.idClinica = dadosUrl.idEmpresa;
      VariaveisGlobais.token = dadosUrl.token;
      VariaveisGlobais.usuario = dadosUrl.usuario;
      VariaveisGlobais.idEmpresa = dadosUrl.idEmpresa;
      VariaveisGlobais.idUsuario = dadosUrl.idUsuario;
      
      // Salvar no localStorage para persistência
      localStorage.setItem('gsConnect_clinica', JSON.stringify({
        idClinica: dadosUrl.idEmpresa,
        token: dadosUrl.token,
        usuario: dadosUrl.usuario,
        idEmpresa: dadosUrl.idEmpresa,
        idUsuario: dadosUrl.idUsuario
      }));
      
      onContinue();
    } catch (error) {
      console.error('Erro ao criar clínica:', error);
      alert(`Erro ao criar conta: ${error.message || 'Tente novamente.'}`);
    } finally {
      setLoading(false);
    }
  };

  const features = [
    {
      icon: "📱",
      title: "WhatsApp Automático",
      description: "Envie mensagens automaticamente via WhatsApp para seus pacientes"
    },
    {
      icon: "🤖",
      title: "Automações Inteligentes",
      description: "Configure lembretes, confirmações e mensagens de aniversário"
    },
    {
      icon: "📊",
      title: "Dashboard Completo",
      description: "Acompanhe métricas e estatísticas dos seus envios"
    },
    {
      icon: "⚡",
      title: "Fácil de Usar",
      description: "Interface intuitiva e configuração em poucos cliques"
    },
    {
      icon: "🔒",
      title: "Seguro e Confiável",
      description: "Seus dados protegidos com máxima segurança"
    },
    {
      icon: "🎯",
      title: "Mensagens Personalizadas",
      description: "Crie templates e personalize suas comunicações"
    }
  ];

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #43a047 0%, #2e7d32 100%)',
      display: 'flex',
      alignItems: 'center'
    }}>
      <Container>
        <Row className="justify-content-center">
          <Col xl={10} lg={11}>
            <Card className="shadow-lg border-0" style={{borderRadius: '20px', overflow: 'hidden'}}>
              {/* Header */}
              <div style={{
                background: 'linear-gradient(135deg, #43a047 0%, #2e7d32 100%)',
                color: 'white',
                padding: '40px 0',
                textAlign: 'center'
              }}>
                {/* <div style={{fontSize: '4rem', marginBottom: '20px'}}>🚀</div> */}
                <h1 style={{fontSize: '2.2rem', fontWeight: '600', marginBottom: '12px'}}>
                  gsConnect
                </h1>
                <p style={{fontSize: '1.1rem', opacity: '0.9', maxWidth: '600px', margin: '0 auto'}}>
                  Sistema de automação para comunicação da clínica via WhatsApp
                </p>
              </div>

              <Card.Body style={{padding: '50px 40px'}}>
                {/* Features Grid */}
                <Row className="mb-5">
                  {features.map((feature, index) => (
                    <Col lg={4} md={6} key={index} className="mb-4">
                      <div className="text-center h-100" style={{padding: '20px'}}>
                        <div style={{
                          fontSize: '3rem',
                          marginBottom: '15px',
                          background: 'linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)',
                          width: '80px',
                          height: '80px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto'
                        }}>
                          {feature.icon}
                        </div>
                        <h5 style={{color: '#2e7d32', fontWeight: '600', marginBottom: '10px'}}>
                          {feature.title}
                        </h5>
                        <p style={{color: '#6c757d', fontSize: '14px', lineHeight: '1.5'}}>
                          {feature.description}
                        </p>
                      </div>
                    </Col>
                  ))}
                </Row>

                {/* Benefits Section */}
                <div style={{
                  background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                  borderRadius: '15px',
                  padding: '30px',
                  marginBottom: '40px'
                }}>
                  <h3 style={{color: '#2e7d32', textAlign: 'center', marginBottom: '30px', fontWeight: '600', fontSize: '20px'}}>
                    Benefícios
                  </h3>
                  <Row>
                    <Col md={6}>
                      <div className="d-flex align-items-center mb-3">
                        <div style={{
                          background: '#43a047',
                          color: 'white',
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px',
                          fontSize: '14px',
                          fontWeight: 'bold'
                        }}>✓</div>
                        <span style={{color: '#495057', fontWeight: '500'}}>Aumente a taxa de comparecimento</span>
                      </div>
                      <div className="d-flex align-items-center mb-3">
                        <div style={{
                          background: '#43a047',
                          color: 'white',
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px',
                          fontSize: '14px',
                          fontWeight: 'bold'
                        }}>✓</div>
                        <span style={{color: '#495057', fontWeight: '500'}}>Reduza faltas e cancelamentos</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <div style={{
                          background: '#43a047',
                          color: 'white',
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px',
                          fontSize: '14px',
                          fontWeight: 'bold'
                        }}>✓</div>
                        <span style={{color: '#495057', fontWeight: '500'}}>Melhore o relacionamento com pacientes</span>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="d-flex align-items-center mb-3">
                        <div style={{
                          background: '#43a047',
                          color: 'white',
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px',
                          fontSize: '14px',
                          fontWeight: 'bold'
                        }}>✓</div>
                        <span style={{color: '#495057', fontWeight: '500'}}>Economize tempo da equipe</span>
                      </div>
                      <div className="d-flex align-items-center mb-3">
                        <div style={{
                          background: '#43a047',
                          color: 'white',
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px',
                          fontSize: '14px',
                          fontWeight: 'bold'
                        }}>✓</div>
                        <span style={{color: '#495057', fontWeight: '500'}}>Automatize processos repetitivos</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <div style={{
                          background: '#43a047',
                          color: 'white',
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px',
                          fontSize: '14px',
                          fontWeight: 'bold'
                        }}>✓</div>
                        <span style={{color: '#495057', fontWeight: '500'}}>Obtenha relatórios detalhados</span>
                      </div>
                    </Col>
                  </Row>
                </div>

                {/* Pricing Section */}
                <div style={{
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  padding: '20px',
                  marginBottom: '30px',
                  border: '1px solid #dee2e6'
                }}>
                  <div className="text-center">
                    <h4 style={{color: '#495057', marginBottom: '15px', fontWeight: '600', fontSize: '18px'}}>
                      Investimento
                    </h4>
                    <div style={{
                      background: 'white',
                      borderRadius: '6px',
                      padding: '15px',
                      marginBottom: '15px',
                      border: '1px solid #e9ecef'
                    }}>
                      <div style={{
                        fontSize: '1.8rem',
                        fontWeight: '600',
                        color: '#495057',
                        marginBottom: '3px'
                      }}>
                        R$ 0,14
                      </div>
                      <div style={{
                        fontSize: '0.9rem',
                        color: '#6c757d',
                        fontWeight: '400'
                      }}>
                        por mensagem enviada
                      </div>
                    </div>
                    <div className="d-flex justify-content-center gap-4">
                      <div className="d-flex align-items-center">
                        <div style={{
                          background: '#28a745',
                          color: 'white',
                          width: '16px',
                          height: '16px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '8px',
                          fontSize: '10px',
                          fontWeight: 'bold'
                        }}>✓</div>
                        <span style={{color: '#495057', fontWeight: '400', fontSize: '14px'}}>Sem mensalidade</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <div style={{
                          background: '#28a745',
                          color: 'white',
                          width: '16px',
                          height: '16px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '8px',
                          fontSize: '10px',
                          fontWeight: 'bold'
                        }}>✓</div>
                        <span style={{color: '#495057', fontWeight: '400', fontSize: '14px'}}>Cobrança automática</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* CTA Section */}
                <div className="text-center">
                  <h4 style={{color: '#2e7d32', marginBottom: '20px', fontWeight: '600'}}>
                    Pronto para começar?
                  </h4>
                  <p style={{color: '#6c757d', marginBottom: '30px', fontSize: '16px'}}>
                    Configure sua conta em segundos e comece a usar todas as funcionalidades
                  </p>
                  <Button
                    size="lg"
                    onClick={handleContinue}
                    disabled={loading}
                    style={{
                      background: 'linear-gradient(135deg, #43a047 0%, #2e7d32 100%)',
                      border: 'none',
                      borderRadius: '50px',
                      padding: '15px 50px',
                      fontSize: '18px',
                      fontWeight: '600',
                      boxShadow: '0 8px 25px rgba(67, 160, 71, 0.3)',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 12px 35px rgba(67, 160, 71, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 8px 25px rgba(67, 160, 71, 0.3)';
                    }}
                  >
                    {loading ? (
                      <span style={{color: 'white'}}>
                        <Spinner size="sm" className="me-2" />
                        Configurando...
                      </span>
                    ) : (
                      <span style={{color: 'white'}}>
                        🚀 Continuar
                      </span>
                    )}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default WelcomePage;
